<template>
    <div class="col my-3">
        <div class="card h-100" style="margin-bottom: 20px; min-width: 250px;">
            <div class="mt-3" style="min-height:200px">
                <a :href="'/product/'+item.id" class="showloading">
                    <img 
                        :src="item.image_path !== null ? '/storage/'+item.image_path+'?filever='+ver : '/images/WillCall_NoImage_500.jpg'" 
                        class="card-img-top img-fluid mx-auto"
                        style="max-width:250px; max-height:250px; width:auto; display: block;"
                        alt="product image" 
                    >
                </a>
            </div>
            <div class="card-body pb-1">
                <a :href="'/product/'+item.id" class="showloading"><h5 class="card-title">{{ item.name }}</h5></a>
                <p class="text-muted"> {{item.brand}} </p>
                <p class="text-muted"> {{item.details}} </p>
                <p class="text-muted"> Item #:{{item.id}} </p>
                <p v-if=" item.is_special == 0 "><strong>{{ '$' + item.price.toFixed(2) }}</strong></p>
                <p v-else><strong><strike>{{ '$' + item.price.toFixed(2) }}</strike><br>{{ '$' + item.special_price.toFixed(2) }}</strong> *SPECIAL*</p>
                <p class="text-danger" v-if="item.stock == 'low'"> <b>Limited Quantity Available </b></p>
            </div>
            <div v-if="item.stock == 'out' && item.category != 'Featured'" class="card-footer border-0" style="background-color: white;">
                <div class="row justify-content-center">
                    <a href="#" class="btn btn-secondary disabled" tabindex="-1" role="button" aria-disabled="true">OUT OF STOCK</a>
                </div>
            </div>
            <div v-else class="card-footer border-0" style="background-color: white;">
                <div class="row justify-content-center mb-3">
                    <div class="qty-input">
                        <i class="fas fa-minus" @click="changeQuantity"></i>
                        <input v-model.number="quantity" type="number" @blur="checkQuantity" />
                        <i class="fas fa-plus" @click="changeQuantity"></i>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <button class="btn btn-success" @click="addToCart" title="add to cart">
                        <i class="fa fa-shopping-cart"></i> ADD TO CART
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data: function () {
            return {
                quantity: 1,
                ver: moment(this.item.updated_at).format('X')
            }
        },
        methods: {
            checkQuantity() {
                if (this.quantity < 1) {
                    this.quantity = 1;
                }

                if(this.item.stock == 'low') {
                    if(this.quantity > 5){
                        this.quantity = 5;
                    }
                }   
            },
            changeQuantity() {
                if ($(event.target).hasClass('fa-minus')) {
                    this.quantity = this.quantity - 1;
                } else if ($(event.target).hasClass('fa-plus')) {
                    this.quantity = this.quantity + 1;
                }

                this.checkQuantity();
            },
            addToCart() {           
                const formData = new FormData();
                formData.append("id", this.item.id);
                formData.append("quantity",this.quantity);
                
                axios.post("/cart/add", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(response => {  
                    Event.fire('updateCart',{}); 
                    $("#itemadded").addClass('show');
                    window.setTimeout(function () {                        
                        $("#itemadded").removeClass('show');
                    }, 2000);
                });
            }
        }
    }
</script>
